export const Action = {
  LISTMESSAGE: "LISTMESSAGE",
  ADDMESSAGE: "ADDMESSAGE"
};
export const Mutation = {
  ADDMESSAGE: "ADDMESSAGE",
  DELMESSAGE: "DELMESSAGE"
};
